import React, {useContext} from "react";
import AuthContext from "../context/AuthContext";
import showContext from "../context/ShowContext";

export default function Login() {

    let {loginUser} = useContext(AuthContext)
    let {isRendered, hideLogin} = useContext(showContext)

    const isVisible = isRendered.login ? "visible" : "hidden";
    return (
        <div className={`login ${isVisible}`}>
            <form className={"login__form"} onSubmit={loginUser}>
                <fieldset className={"login__fieldset"}>
                    <legend className={"offscreen login__legend"}>Enter Your Username and Password to Log in</legend>
                    <p className={"login__p"}>
                        <label className={"login__label"} htmlFor={"username"}> Username: </label>
                        <input className={"login__input"} type={"text"} id={"username"} name={"username"} placeholder={"Username"} required/>

                    </p>

                    <p className={"login__p"}>
                        <label className={"login__label"} htmlFor={"password"}> Password: </label>
                        <input className={"login__input"} type={"password"} id={"password"} name={"password"} placeholder={"Password"} required/>

                    </p>
                </fieldset>
                    <div className={"login__btns"}>
                        <button className={"button login__button button--cancel"} type={"button"} onClick={hideLogin}>Cancel</button>
                        <button className={"button login__button button--submit"} type={"submit"} value={"Log in"}> Log in </button>
                    </div>
            </form>
        </div>
    )
}